module.exports = __webpack_public_path__ + "img/Quallen.1da67cd0.svg";